var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleField',{attrs:{"disabled":_vm.disabled,"mode":"Decimal","operators":_vm.operators,"value":_vm.mutableValue},on:{"update:value":function($event){_vm.mutableValue=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }